import { cfm } from '@ourbranch/brand-product';
import { createColorPalette } from '@ourbranch/ui-core';
import { withBrandProduct } from '../../lib/with-brand-product';
const cfmColorPalette = createColorPalette({
    primaryMain: '#123257',
    backgroundsMain: '#F0F0F0',
    typographyMain: '#545759',
    controlsMain: '#E6E7E8',
    errorMain: '#7A0027'
});
const frontendConfig = {
    constants: {
        SUPPORT_RENEWAL_AND_CANCEL_QUESTIONS_PHONE: '800-218-2223',
        CLAIMS_PHONE: '800-218-2223',
        CLAIMS_EMAIL: 'claims@cfmimo.com',
        // #37458: CFM claims are reported on Liberate's online forms, separate ones for property and auto.
        CLAIMS_FNOL_LINKS: [
            { label: 'File a Property Claim', url: 'https://cfm.ember.liberate.claims/fnol' },
            { label: 'File an Auto Claim', url: 'https://cfm.ember.liberate.claims/fnol-auto' }
        ],
        AGENCY_SUPPORT_PHONE: '',
        AGENCY_SUPPORT_HOURS: '',
        MEMBER_COMMS_EMAIL: 'this-is@a.placeholder',
        SMS_SHORTCODE: '',
        // TODO: Get terms of use URL for CFM
        TERMS_OF_USE_URL: '#',
        // TODO: Get communications consent URL for CFM
        COMMUNICATIONS_CONSENT_URL: '#',
        IOS_APP_STORE_URL: '#',
        ANDROID_GOOGLE_PLAY_STORE_URL: '#',
        // Blank: the credit-card fee note is inaccurate for this mutual (#33401).
        SMALL_BILLING_NOTE: ''
    },
    theme: {
        palette: {
            ...cfmColorPalette,
            backgrounds: {
                ...cfmColorPalette.backgrounds,
                lightContrast: '#EFF0F1',
                // modals get a white background to contrast with callouts
                modal: '#FFFFFF'
            }
        },
        loaderColor: '#D29329',
        showLogoInLoader: false,
        showAccountBackgroundHero: false,
        logoWidthDesktop: 320,
        logoWidthMobile: 230
    },
    config: {
        // CFM charges a credit-card fee (parity with Forreston); gates the CC-fee disclaimers/breakdown
        // at checkout. Without it those disclosures silently do not render.
        supportedFees: {
            creditCard: true
        },
        // Migrated members are not charged the card fee on the imported term, nor on any renewal in its
        // lineage with a rate control date before the cutoff. Must equal brand-config-be brands/cfm.ts
        // fees.farm.cardFeeExemption (what billing charges by) — a test in each package fails until both match.
        cardFeeExemption: { importedTerm: true, importedLineageRateControlDateBefore: '2027-06-01' },
        // CFM fee schedule (issue #34828). Mirrors packages/brand-config-be/src/brands/cfm.ts `fees` so
        // the staff Fee Selector computes the same manually-added fee amounts the backend charges. FO=Farm
        // (F), HO/TO=Home (Z)/Rental (Y) use `farm`; PA=Auto (A) uses `auto`. KEEP IN SYNC with the BE.
        fees: {
            farm: {
                policyFee: 150,
                dwellingPolicyFeePerDwelling: 0,
                reinstatementFee: 50,
                nsfFee: 35,
                installmentFees: {
                    directBill: { quarterly: 7, semiAnnual: 7, monthly: 7 },
                    automated: { quarterly: 2, semiAnnual: 2, monthly: 2 }
                },
                applyCreditCardFee: true,
                // No installment fee on the new-business down payment (#36489).
                installmentFeeOnDownPayment: false
            },
            auto: {
                policyFee: 75,
                renewalPolicyFee: 75,
                rewritePolicyFee: 25,
                reinstatementFee: 25,
                nsfFee: 25,
                latePaymentFee: 10,
                // Auto bills Monthly or in 2 payments (#36200; see brand-config-be cfm.ts).
                installmentFees: {
                    directBill: { monthly: 7, semiAnnual: 7 },
                    automated: { monthly: 2, semiAnnual: 2 }
                },
                applyCreditCardFee: true,
                // GO's auto pay plans (#36489, #36492): no installment fee on the new-business down payment;
                // Monthly new business is 5 equal installments.
                installmentFeeOnDownPayment: false,
                newBusinessMonthlyInstallmentCount: 5
            }
        }
    }
};
const brand = withBrandProduct(cfm, frontendConfig);
export const constants = brand.constants;
export const theme = brand.theme;
export default brand.config;
